import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { TECHNIQUES } from '../siteNav';
import { PageHero, PageShell, PlaceholderList, QuoteBand } from '../components/site/PageParts';
import useSeo from '../hooks/useSeo';

const LEGACY_TECHNIQUES = { 'heat-press': 'dtf-printing' };

export default function TechniquePage() {
  const { technique } = useParams();
  const t = TECHNIQUES.find((x) => x.slug === technique);
  useSeo({
    title: t ? `${t.name} | Merch Production | Pusha Teez` : '',
    description: t?.intro,
    path: t && `/production/${t.slug}`,
    image: t?.img,
    noindex: true,
  });
  if (!t) return <Navigate to={LEGACY_TECHNIQUES[technique] ? `/production/${LEGACY_TECHNIQUES[technique]}` : '/production'} replace />;
  return (
    <PageShell testid={`technique-page-${t.slug}`}>
      <PageHero eyebrow="Production" title={t.name} intro={t.intro} img={t.img}>
        <Link to="/production" className="inline-flex items-center gap-2 mt-8 text-sm text-[#cfc8bb] hover:text-[#00b8ff] transition-colors duration-200" data-testid="back-to-production">
          <ArrowLeft className="w-4 h-4" />All production techniques
        </Link>
      </PageHero>
      <PlaceholderList
        items={[
          { title: 'What we offer', placeholder: `Describe your ${t.name.toLowerCase()} services, products and finishes` },
          { title: 'Minimums', text: t.minimum || 'No minimum order.' },
          { title: 'Turnaround', placeholder: 'Typical turnaround time — to be filled in' },
          { title: 'Pricing', placeholder: 'Pricing details or price ranges — to be filled in' },
          { title: 'Garments & products', placeholder: 'Blanks, brands and products available — to be filled in' },
          { title: 'Example projects', placeholder: 'Project examples and photos — to be filled in' },
        ]}
      />
      <QuoteBand title={`Start a ${t.name} order`} />
    </PageShell>
  );
}
